(function($){
    // create span element to display file name
    $('.fileinput').each(function() {
        $(this).prepend('<span class="file-name empty">File name</span>');

        var label = $('.file-name', this);
        var labelVal = $('.file-name', this).html();

        // if input value changes (someone selects a file), show file name in span
        $(".ginput_container_fileupload input", this).change(function() {
            var fileName = '';

            if ($(this).val()) {
                var val = $(this).val();
                fileName = val.split( '\\' ).pop();
            }

            if (fileName) {
                label.html(fileName);
                label.removeClass('empty');
            }
            else {
                label.html(labelVal);
                label.addClass('empty');
            }
        });
    });

})(jQuery);